import { Dialog, type DialogProps } from '@mui/material';

import {
  Content,
  CustomFooter,
  CustomHeader,
  Footer,
  Header
} from './components';

type Props = DialogProps & {
  width?: string;
  height?: string;
  disableScrollContent?: boolean;
};

const Modal = ({
  open,
  onClose,
  width,
  height,
  children,
  disableScrollContent = false,
  ...props
}: Props) => {
  const customSx = {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        ...(width && { width: '100%', maxWidth: width }),
        ...(height && { height: '100%', maxHeight: height })
      }
    },
    ...(disableScrollContent && {
      '& .MuiDialogContent-root': {
        padding: '0px',
        overflowY: 'hidden'
      }
    })
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      {...props}
      sx={{
        ...props.sx,
        ...customSx
      }}
    >
      {children}
    </Dialog>
  );
};

Modal.CustomHeader = CustomHeader;
Modal.Header = Header;
Modal.Content = Content;
Modal.Footer = Footer;
Modal.CustomFooter = CustomFooter;

export default Modal;
